import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CookiePolicy() {
  return (
    <div className="bg-[#FBFBF9] min-h-screen pt-32 pb-24" data-testid="cookie-policy-page">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        <Link to="/" data-testid="back-home-link" className="inline-flex items-center gap-2 text-sm text-[#555] hover:text-[#111] mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Torna alla home
        </Link>
        <div className="overline">Informativa</div>
        <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#111]">Cookie Policy</h1>
        <p className="text-[#555] mt-4 text-sm">Ultimo aggiornamento: 10 giugno 2026</p>

        <div className="mt-12 text-[#111] leading-relaxed space-y-8">
          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">1. Cosa sono i cookie</h2>
            <p>
              I cookie sono piccoli file di testo che i siti web visitati dagli utenti inviano ai loro
              dispositivi (computer, tablet, smartphone), dove vengono memorizzati per essere poi
              ritrasmessi agli stessi siti alla visita successiva. I cookie sono utilizzati per diverse finalità
              (esecuzione di autenticazioni informatiche, monitoraggio di sessioni, memorizzazione di preferenze).
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">2. Tipologie di cookie utilizzati su questo sito</h2>

            <div className="mt-4 border border-[#E5E5E0] bg-white">
              <div className="p-5 border-b border-[#E5E5E0]">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="font-medium text-[#111]">Cookie tecnici (necessari)</h3>
                  <span className="text-xs uppercase tracking-wider text-[#1B3022] font-medium">Sempre attivi</span>
                </div>
                <p className="text-sm text-[#555] mt-2 leading-relaxed">
                  Indispensabili per il corretto funzionamento del sito. Memorizzano informazioni
                  tecniche come la preferenza espressa sul banner cookie. Non richiedono il consenso
                  dell'utente (art. 122 D.Lgs. 196/2003).
                </p>
                <div className="mt-3 text-xs text-[#555]">
                  <strong>Cookie/storage utilizzati:</strong> <code className="bg-[#F0F0EB] px-2 py-0.5">mc_cookie_consent_v1</code> (localStorage) – durata: persistente fino a revoca
                </div>
              </div>

              <div className="p-5">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="font-medium text-[#111]">Cookie analitici</h3>
                  <span className="text-xs uppercase tracking-wider text-[#555] font-medium">Non in uso</span>
                </div>
                <p className="text-sm text-[#555] mt-2 leading-relaxed">
                  Attualmente <strong>non sono in uso</strong> cookie analitici (es. Google Analytics) o di profilazione.
                  Qualora venissero in futuro attivati, verranno utilizzati solo previo consenso espresso dell'utente
                  tramite il banner cookie e questa informativa sarà aggiornata di conseguenza.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">3. Cookie di terze parti</h2>
            <p>
              Il sito non utilizza al momento cookie di profilazione di terze parti. I servizi tecnici di terze parti
              utilizzati (es. invio email tramite Resend, hosting) non installano cookie sul dispositivo dell'utente.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">4. Come gestire le preferenze sui cookie</h2>
            <p>L'utente può in qualsiasi momento:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>
                Modificare le proprie preferenze cookie cancellando il dato salvato dal browser
                (impostazioni del browser → cancella dati di navigazione → siti web → consulenzamarano.com)
              </li>
              <li>
                Disabilitare completamente i cookie dalle impostazioni del proprio browser
                (in tal caso alcune funzionalità del sito potrebbero non essere disponibili)
              </li>
              <li>
                Richiedere informazioni o esercitare i propri diritti scrivendo a{" "}
                <a href="mailto:info@consulenzamarano.com" className="text-[#1B3022] underline">info@consulenzamarano.com</a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">5. Riferimenti normativi</h2>
            <ul className="list-disc pl-6 mt-3 space-y-2 text-sm text-[#555]">
              <li>Regolamento (UE) 2016/679 (GDPR)</li>
              <li>D.Lgs. 196/2003 (Codice Privacy) e successive modifiche</li>
              <li>Provvedimento del Garante Privacy 10 giugno 2021 "Linee guida cookie e altri strumenti di tracciamento"</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">6. Contatti</h2>
            <p>
              Titolare del trattamento: <strong>Marano Consulting</strong> — Via Roma 544/A, 80017 Melito di Napoli (NA)<br />
              Email: <a href="mailto:info@consulenzamarano.com" className="text-[#1B3022] underline">info@consulenzamarano.com</a> · Tel: 081 1836 6932
            </p>
            <p className="mt-3">
              Per approfondimenti sul trattamento dei dati personali, consulta la nostra{" "}
              <Link to="/privacy-policy" className="text-[#1B3022] underline">Privacy Policy</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
